"use client";

import { useEffect, useState } from "react";
import { JsSdkEventEmitInstance } from "@ospweb/sdk-ui";
import { Token } from "agg-swap-client";
import SwapContainer from "./SwapContainer";
import { SwapModal } from "./SwapModal";
import { useIsPc } from "@/src/hooks";

interface SwapSingleModalProps {
  visible: boolean;
  data: Token;
}

const swapUrls = {
  dev: "https://swapapp-beta.vercel.app/trade",
  beta: "https://swapapp-beta.vercel.app/trade",
  pre: "https://swap.edwealth.ai/trade",
  prod: "https://swap.edwealth.ai/trade",
};

export const SwapSingleModal = () => {
  const [swapModalVisible, setSwapModalVisible] = useState(false);
  const [isPc] = useIsPc();
  const [data, setData] = useState<Token | null>(null);

  useEffect(() => {
    const removeListener =
      JsSdkEventEmitInstance.addEventListener<SwapSingleModalProps>(
        "swap-single-modal",
        (data) => {
          setData(data.data);
          setSwapModalVisible(data.visible);
        },
      );
    return () => {
      removeListener();
    };
  }, []);

  return (
    <SwapModal
      visible={swapModalVisible}
      mask={!isPc}
      placement={isPc ? "center" : "bottom"}
      onClose={() => {
        setSwapModalVisible(false);
      }}
    >
      <SwapContainer
        // 避免undefined
        // 避免undefined
        url={
          data?.address && data?.chainId
            ? `${swapUrls[process.env.NEXT_PUBLIC_ENV as keyof typeof swapUrls]}?tokenAddress=${data?.address}&chainId=${data?.chainId}`
            : `${swapUrls[process.env.NEXT_PUBLIC_ENV as keyof typeof swapUrls]}`
        }
        onExit={() => {
          setSwapModalVisible(false);
        }}
      />
    </SwapModal>
  );
};

SwapSingleModal.setVisible = (visible: boolean, data?: Token) => {
  JsSdkEventEmitInstance.emitEvent("swap-single-modal", { visible, data });
};
